import { useContext } from "react";
import { ThemeContext } from "./ThemeContext.js";

/**
 * Hook osobno od providera, zeby Fast Refresh dzialal poprawnie: plik eksportujacy
 * jednoczesnie komponent i zwykla funkcje traci granice odswiezania.
 */
export function useTheme(): NonNullable<React.ContextType<typeof ThemeContext>> {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error("useTheme wymaga ThemeProvider");
  return ctx;
}
